module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"add-tag":"Add a tag","no-tags-yet":"No tags yet"},"fr_FR":{"add-tag":"Ajouter un tag","no-tags-yet":"Pas encore de tags"}}')
  delete Component.options._Ctor
}
